/* eslint-disable no-restricted-syntax */

import { nl2br } from "./_text_utils";

/* eslint-disable camelcase */
interface Comment {
  place_name: string;
  text: string;
}
interface Recommender {
  post_title: string,
}
interface RecommenderAdditional {
  icon_url: string;
  recommender_url: string;
  twitter_url?: string;
  instagram_url?: string;
  profile: string;
  human_url?: string;
}
interface Recommend {
  recommender: Recommender;
  text: string;
  recommender_additional: RecommenderAdditional;
  comments: Comment[];
}

// const recommends:Recommend[]=[];

export default class RecommendSwitcher {
  recommends: Recommend[];

  currentIndex: number | null = null;

  isActive = true;

  commentSwitchElement: HTMLElement;

  commentPopElement: HTMLElement;

  commentAuthorElement: HTMLElement;

  keyvisualCommentStatus: HTMLElement;

  prevElement: HTMLElement;

  nextElement: HTMLElement;

  commentStatusElement: HTMLElement;

  commentSwitchButtonOffElement: HTMLElement;

  commentSwitchButtonOnElement: HTMLElement;

  recommenderElement: HTMLAnchorElement;

  recommenderNameElement: HTMLElement;

  textElement: HTMLElement;

  iconElement: HTMLImageElement;

  authorRecommenderElement: HTMLElement;

  authorRecommenderNameLinkElement: HTMLAnchorElement;

  authorRecommenderSnsLinkTwitterElement: HTMLAnchorElement;

  authorRecommenderSnsLinkInstagramElement: HTMLAnchorElement;

  authorRecommenderDescriptionElement: HTMLElement;

  authorRecommenderEyecatchLinkElement: HTMLAnchorElement;

  authorRecommenderEyecatchImageElement: HTMLImageElement;

  authorRecommenderButtonElement: HTMLAnchorElement;

  constructor(recommends: Recommend[]) {

    const commentSwitchElement = document.querySelector(".c-content-articles__comment-switch") as HTMLElement;
    if (!commentSwitchElement) {
      throw new Error("commentSwitchElement is null");
    }
    this.commentSwitchElement = commentSwitchElement;

    const commentPopElement = document.querySelector(".c-content-articles__comment-pop") as HTMLElement;
    if (!commentPopElement) {
      throw new Error("commentPopElement is null");
    }
    this.commentPopElement = commentPopElement;

    const commentAuthorElement = document.querySelector(".c-content-articles__comment-author") as HTMLElement;
    if (!commentAuthorElement) {
      throw new Error("commentAuthorElement is null");
    }
    this.commentAuthorElement = commentAuthorElement;

    const keyvisualCommentStatus = document.querySelector(".c-content-articles__keyvisual-comment-status") as HTMLElement;
    if (!keyvisualCommentStatus) {
      throw new Error("keyvisualCommentStatus is null");
    }
    this.keyvisualCommentStatus = keyvisualCommentStatus;

    const prevElement = document.querySelector(".c-content-articles__comment-switch-control--prev") as HTMLElement;
    if (!prevElement) {
      throw new Error("prevElement is null");
    }
    this.prevElement = prevElement;

    const nextElement = document.querySelector(".c-content-articles__comment-switch-control--next") as HTMLElement;
    if (!nextElement) {
      throw new Error("nextElement is null");
    }
    this.nextElement = nextElement;

    const commentStatusElement = document.querySelector(".c-content-articles__keyvisual-comment-status") as HTMLElement;
    if (!commentStatusElement) {
      throw new Error("commentStatusElement is null");
    }
    this.commentStatusElement = commentStatusElement;

    const commentSwitchButtonOffElement = document.querySelector(".c-content-articles__comment-switch-button--off") as HTMLElement;
    if (!commentSwitchButtonOffElement) {
      throw new Error("commentSwitchButtonOffElement is null");
    }
    this.commentSwitchButtonOffElement = commentSwitchButtonOffElement;

    const commentSwitchButtonOnElement = document.querySelector(".c-content-articles__comment-switch-button--on") as HTMLElement;
    if (!commentSwitchButtonOnElement) {
      throw new Error("commentSwitchButtonOffElement is null");
    }
    this.commentSwitchButtonOnElement = commentSwitchButtonOnElement;

    const recommenderElement = document.querySelector(".c-content-articles__comment-author") as HTMLAnchorElement;
    if (!recommenderElement) {
      throw new Error("recommenderElement is null");
    }
    this.recommenderElement = recommenderElement;

    const recommenderNameElement = document.querySelector(".c-content-articles__comment-author-name") as HTMLElement;
    if (!recommenderNameElement) {
      throw new Error("recommenderNameElement is null");
    }
    this.recommenderNameElement = recommenderNameElement;

    const textElement = document.querySelector(".c-content-articles__comment") as HTMLElement;
    if (!textElement) {
      throw new Error("textElement is null");
    }
    this.textElement = textElement;

    const iconElement = document.querySelector(".c-content-articles__comment-author-icon img") as HTMLImageElement;
    if (!iconElement) {
      throw new Error("iconElement is null");
    }
    this.iconElement = iconElement;

    const authorRecommenderElement = document.querySelector(".c-single-author--recommender") as HTMLElement;
    if (!authorRecommenderElement) {
      throw new Error("authorRecommenderElement is null");
    }
    this.authorRecommenderElement = authorRecommenderElement;

    const authorRecommenderNameLinkElement = authorRecommenderElement.querySelector("a.c-single-author__name-link") as HTMLAnchorElement;
    if (!authorRecommenderNameLinkElement) {
      throw new Error("authorRecommenderNameLinkElement is null");
    }
    this.authorRecommenderNameLinkElement = authorRecommenderNameLinkElement;

    const authorRecommenderSnsLinkTwitterElement = authorRecommenderElement.querySelector("a.c-single-author__sns-link--twitter") as HTMLAnchorElement;
    if (!authorRecommenderSnsLinkTwitterElement) {
      throw new Error("authorRecommenderSnsLinkTwitterElement is null");
    }
    this.authorRecommenderSnsLinkTwitterElement = authorRecommenderSnsLinkTwitterElement;

    const authorRecommenderSnsLinkInstagramElement = authorRecommenderElement.querySelector("a.c-single-author__sns-link--instagram") as HTMLAnchorElement;
    if (!authorRecommenderSnsLinkInstagramElement) {
      throw new Error("authorRecommenderSnsLinkInstagramElement is null");
    }
    this.authorRecommenderSnsLinkInstagramElement = authorRecommenderSnsLinkInstagramElement;

    const authorRecommenderDescriptionElement = authorRecommenderElement.querySelector(".c-single-author__description") as HTMLElement;
    if (!authorRecommenderDescriptionElement) {
      throw new Error("authorRecommenderDescriptionElement is null");
    }
    this.authorRecommenderDescriptionElement = authorRecommenderDescriptionElement;

    const authorRecommenderEyecatchLinkElement = authorRecommenderElement.querySelector(".c-single-author__eyecatch a") as HTMLAnchorElement;
    if (!authorRecommenderEyecatchLinkElement) {
      throw new Error("authorRecommenderEyecatchLinkElement is null");
    }
    this.authorRecommenderEyecatchLinkElement = authorRecommenderEyecatchLinkElement;

    const authorRecommenderEyecatchImageElement = authorRecommenderElement.querySelector(".c-single-author__eyecatch img") as HTMLImageElement;
    if (!authorRecommenderEyecatchImageElement) {
      throw new Error("authorRecommenderEyecatchLinkElement is null");
    }
    this.authorRecommenderEyecatchImageElement = authorRecommenderEyecatchImageElement;

    const authorRecommenderButtonElement = authorRecommenderElement.querySelector("a.c-single-author__button") as HTMLAnchorElement;
    if (!authorRecommenderButtonElement) {
      throw new Error("authorRecommenderButtonElement is null");
    }
    this.authorRecommenderButtonElement = authorRecommenderButtonElement;


    this.recommends = recommends;
    if (this.recommends.length === 0) {
      this.removeElements();
      return;
    }
    if (this.recommends.length === 1) {
      this.removeNextPrev();
    }
    this.setupEvents();
    this.updateRecommend(0);
  }

  // eslint-disable-next-line class-methods-use-this
  removeElement(element: HTMLElement) {
    if (!element) {
      throw new Error("element is null");
    }
    if (!element.parentNode) {
      throw new Error("element.parentNode is null");
    }
    element.parentNode.removeChild(element);
  }

  removeElements() {
    this.removeElement(this.commentSwitchElement);
    this.removeElement(this.commentPopElement);
    this.removeElement(this.commentAuthorElement);
    this.removeElement(this.keyvisualCommentStatus);
    this.removeElement(this.authorRecommenderElement);
  }

  removeNextPrev() {
    this.removeElement(this.nextElement);
    this.removeElement(this.prevElement);
  }

  setupEvents() {
    this.prevElement.addEventListener("click", () => {
      if (this.currentIndex == null) {
        return;
      }
      const index = (this.currentIndex + this.recommends.length - 1) % this.recommends.length;
      this.updateRecommend(index);
    });
    this.nextElement.addEventListener("click", () => {
      if (this.currentIndex == null) {
        return;
      }
      const index = (this.currentIndex + 1) % this.recommends.length;
      this.updateRecommend(index)
    });

    this.commentStatusElement.addEventListener("click", () => {
      this.isActive = !this.isActive;
      this.updateCommentsVisibility();
    });
    this.commentSwitchButtonOffElement.addEventListener("click", () => {
      this.isActive = false;
      this.updateCommentsVisibility();
    });
    this.commentSwitchButtonOnElement.addEventListener("click", () => {
      this.isActive = true;
      this.updateCommentsVisibility();
    });

  }

  updateRecommend(index: number | null) {
    // const statusElement = document.querySelector(".controller__status")
    // if (!statusElement) {
    //   throw new Error("statusElement is null");
    // }
    const commentBlockPlaceElementList = document.querySelectorAll(".c-block-comment-place") as NodeListOf<HTMLDivElement>;

    this.recommenderNameElement.textContent = "";
    this.textElement.innerHTML = "";
    this.iconElement.src = "";
    this.recommenderElement.href = "";

    this.authorRecommenderNameLinkElement.href = "";
    this.authorRecommenderNameLinkElement.textContent = "";
    this.authorRecommenderSnsLinkTwitterElement.style.display = "none";
    this.authorRecommenderSnsLinkTwitterElement.href = "";
    this.authorRecommenderSnsLinkInstagramElement.style.display = "none";
    this.authorRecommenderSnsLinkInstagramElement.href = "";
    this.authorRecommenderDescriptionElement.innerHTML = "";
    this.authorRecommenderEyecatchLinkElement.href = "";
    this.authorRecommenderEyecatchImageElement.src = "";
    this.authorRecommenderButtonElement.style.display = "none";
    this.authorRecommenderButtonElement.href = "";



    for (const commentBlockPlaceElement of commentBlockPlaceElementList) {
      while (commentBlockPlaceElement.firstChild) {
        commentBlockPlaceElement.removeChild(commentBlockPlaceElement.firstChild);
      }
    }
    if (index != null) {

      if (this.recommends.length < index) {
        throw new Error("out of range");
      }
      const recommend = this.recommends[index];

      this.recommenderNameElement.textContent = recommend.recommender.post_title;
      this.textElement.innerHTML = nl2br(recommend.text)
      this.iconElement.src = recommend.recommender_additional.icon_url;
      this.recommenderElement.href = recommend.recommender_additional.recommender_url;

      this.authorRecommenderNameLinkElement.href = recommend.recommender_additional.recommender_url;
      this.authorRecommenderNameLinkElement.textContent = recommend.recommender.post_title;
      if (recommend.recommender_additional.twitter_url) {
        this.authorRecommenderSnsLinkTwitterElement.style.display = "inline";
        this.authorRecommenderSnsLinkTwitterElement.href = recommend.recommender_additional.twitter_url;
      }
      if (recommend.recommender_additional.instagram_url) {
        this.authorRecommenderSnsLinkInstagramElement.style.display = "inline";
        this.authorRecommenderSnsLinkInstagramElement.href = recommend.recommender_additional.instagram_url;
      }
      this.authorRecommenderDescriptionElement.innerHTML = nl2br(recommend.recommender_additional.profile);
      this.authorRecommenderEyecatchLinkElement.href = recommend.recommender_additional.recommender_url;
      this.authorRecommenderEyecatchImageElement.src = recommend.recommender_additional.icon_url;
      if (recommend.recommender_additional.human_url) {
        this.authorRecommenderButtonElement.style.display = "block";
        this.authorRecommenderButtonElement.href = recommend.recommender_additional.human_url;
      }



      for (const commentBlockPlaceElement of commentBlockPlaceElementList) {
        const placeName = commentBlockPlaceElement.dataset.place_name;
        const commentInPlaceList = recommend.comments.filter((comment) => comment.place_name === placeName);
        for (const commentInPlace of commentInPlaceList) {
          const commentBalloon = document.createElement("div");
          commentBalloon.classList.add("c-comment-balloon");
          commentBlockPlaceElement.appendChild(commentBalloon);
          const commentBalloonText = document.createElement("div");
          commentBalloonText.classList.add("c-comment-balloon__text");
          commentBalloonText.textContent = commentInPlace.text;
          commentBalloon.appendChild(commentBalloonText);
          const commentBalloonIcon = document.createElement("img");
          commentBalloonIcon.classList.add("c-comment-balloon__icon");
          commentBalloonIcon.src = recommend.recommender_additional.icon_url;
          commentBalloon.appendChild(commentBalloonIcon);
        }
      }
    }
    this.currentIndex = index;
    // statusElement.textContent = `${this.currentIndex == null ? "null" : this.currentIndex + 1}/${this.recommends.length}`;
    this.updateCommentsVisibility();
  }

  updateCommentsVisibility() {
    this.commentStatusElement.classList.remove("is-active");
    if (this.isActive) {
      this.commentStatusElement.classList.add("is-active");
    }
    this.commentSwitchButtonOffElement.classList.remove("is-active");
    if (!this.isActive) {
      this.commentSwitchButtonOffElement.classList.add("is-active");
    }
    this.commentSwitchButtonOnElement.classList.remove("is-active");
    if (this.isActive) {
      this.commentSwitchButtonOnElement.classList.add("is-active");
    }

    this.commentPopElement.style.display = this.isActive ? "" : "none";
    this.commentAuthorElement.style.display = this.isActive ? "" : "none";
    this.authorRecommenderElement.style.display = this.isActive ? "" : "none";


    // balloonはこのタイミングでqueryする必要がある
    const balloonElementList = document.querySelectorAll(".c-comment-balloon") as NodeListOf<HTMLElement>;
    for (const balloonElement of balloonElementList) {
      balloonElement.style.display = this.isActive ? "" : "none";
    }


  }

}